// /src/theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#94C940", // Your custom green
      contrastText: "#ffffff"
    },
    secondary: {
      main: "#5A6872", // Optional secondary
    },
  },
});

export default theme;